import { IconWrapper } from '../runtime';
export default IconWrapper('folder-team-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.25 20.25C1.00736 20.25 0 19.2426 0 18L0 3C0 1.75736 1.00736 0.75 2.25 0.75L6.75 0.75C7.23683 0.75 7.71053 0.9079 8.1 1.2L9.9 2.55C10.2895 2.8421 10.7632 3 11.25 3L21.75 3C22.9926 3 24 4.00736 24 5.25L24 18C24 19.2426 22.9926 20.25 21.75 20.25L2.25 20.25Z",
      "fill": "#317FF2"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.25 22.5C1.00736 22.5 0 21.4926 0 20.25L0 7.5C0 6.25736 1.00736 5.25 2.25 5.25L21.75 5.25C22.9926 5.25 24 6.25736 24 7.5L24 20.25C24 21.4926 22.9926 22.5 21.75 22.5L2.25 22.5Z",
      "fill": 'url(#' + props.id + '7e41169a' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.625 10.7812C11.625 11.8168 10.7855 12.6562 9.75 12.6562C8.71447 12.6562 7.875 11.8168 7.875 10.7812C7.875 9.74572 8.71447 8.90625 9.75 8.90625C10.7855 8.90625 11.625 9.74572 11.625 10.7812ZM6.65625 16.0312C6.65625 14.5815 7.8315 13.4062 9.28125 13.4062H10.4062C11.1345 13.4062 11.7936 13.7028 12.2691 14.1818C12.326 14.2392 12.3804 14.2991 12.4318 14.3615C12.8063 14.8153 13.0312 15.397 13.0312 16.0312V17.3438C13.0312 17.758 12.6955 18.0938 12.2812 18.0938H7.40625C6.99204 18.0938 6.65625 17.758 6.65625 17.3438V16.0312ZM13.9688 13.4062C13.7016 13.4062 13.4453 13.4528 13.2076 13.5382C13.7977 14.2008 14.1562 15.0742 14.1562 16.0312V17.3438H16.5938C17.008 17.3438 17.3438 17.008 17.3438 16.5938V15.6562C17.3438 14.4136 16.3364 13.4062 15.0938 13.4062H13.9688ZM14.4375 12.6562C15.2659 12.6562 15.9375 11.9847 15.9375 11.1562C15.9375 10.3278 15.2659 9.65625 14.4375 9.65625C13.6091 9.65625 12.9375 10.3278 12.9375 11.1562C12.9375 11.9847 13.6091 12.6562 14.4375 12.6562Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '7e41169a',
      "x1": "2.25",
      "y1": "6.43828",
      "x2": "19.1823",
      "y2": "24.658",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});